module.exports = __webpack_public_path__ + "check-insurance-desktop___1Kcgb.svg";